import React from 'react';
import { FaXTwitter, FaArrowLeft, FaDiscord } from 'react-icons/fa6';
import { SOCIAL_LINKS } from '../../constants/socialLinks';

const SocialLinks = () => {
    return (
        <div className="space-x-6 flex items-center mt-6">
            <a
                href={SOCIAL_LINKS.website}
                className="text-primary hover:text-secondary text-2xl"
                aria-label="Back to Website"
            >
                <FaArrowLeft />
            </a>
            <a
                href={SOCIAL_LINKS.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-secondary text-2xl"
                aria-label="Twitter"
            >
                <FaXTwitter />
            </a>
            <a
                href={SOCIAL_LINKS.discord}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-secondary text-2xl"
                aria-label="Discord"
            >
                <FaDiscord />
            </a>
        </div>
    );
};

export default SocialLinks;